// src/components/dictionary/DictionaryResults.jsx
export default function DictionaryResults({ results, searchText, onAddToDictionary }) {
  if (!searchText?.trim()) {
    return (
      <div className="mt-10 bg-white rounded-xl shadow p-10 text-center text-gray-500">
        Enter a word and search to see translations
      </div>
    );
  }

  if (results?.length === 0) {
    return (
      <div className="mt-10 bg-white rounded-xl shadow p-10 text-center text-gray-600">
        No translations found for "<strong>{searchText}</strong>"
      </div>
    );
  }

  // Group by source word (case-insensitive)
  const grouped = results.reduce((acc, record) => {
    const key = record.source?.toLowerCase() || 'unknown';
    if (!acc[key]) acc[key] = [];
    acc[key].push(record);
    return acc;
  }, {});

  return (
    <div className="mt-8 space-y-6">
      {Object.entries(grouped).map(([sourceWord, entries]) => (
        <div
          key={sourceWord}
          className="bg-white rounded-xl shadow-sm border border-gray-200 overflow-hidden hover:shadow-md transition-shadow duration-200"
        >
          {/* Header – Main word */}
          <div className="bg-gradient-to-r from-blue-50 to-indigo-50 px-6 py-4 border-b border-gray-200">
            <h3 className="text-2xl font-bold text-gray-900 capitalize">
              {sourceWord}
            </h3>
            <p className="text-sm text-gray-600 mt-1">
              {entries.length} {entries.length === 1 ? 'sense' : 'senses'} found
            </p>
          </div>

          {/* Entries / senses */}
          <div className="divide-y divide-gray-100">
            {entries.length > 0 && (
              <div className="p-5">
                <table className="min-w-full border border-gray-200 text-md">
                  <thead className="bg-gray-50">
                    <tr>
                      <th className="border border-gray-200 px-4 py-2 text-left font-semibold w-[220px]">
                        Source (Category)
                      </th>
                      <th className="border border-gray-200 px-4 py-2 text-left font-semibold">
                        Translations
                      </th>
                      {/* Uncomment if you want domain column */}
                      {/* <th className="border border-gray-200 px-4 py-2 text-left font-semibold w-[120px]">Domain</th> */}
                    </tr>
                  </thead>
                  <tbody>
                    {entries.map((record, index) => (
                      <tr key={index} className="hover:bg-gray-50">
                        <td className="border border-gray-200 px-4 py-3 font-medium text-gray-900">
                          {record.source || '—'}{' '}
                          <span className="text-gray-500 text-md">
                            {getCategory(record.sourceWithCat)}
                          </span>
                        </td>
                        <td className="border border-gray-200 px-4 py-3">
                          {record.target?.length > 0 ? (
                            record.target
                              .map(t => t.replace(/_/g, ' '))
                              .join(', ')
                          ) : (
                            '—'
                          )}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}
          </div>
        </div>
      ))}
    </div>
  );
}

// Helper function
function getCategory(sourceWithCat) {
  if (!sourceWithCat || !sourceWithCat.includes('____')) return '';
  const categoryPart = sourceWithCat.split('____')[1]?.trim();
  if (!categoryPart || categoryPart === 'UNDEFINED') return '';
  return `(${categoryPart})`;
}